/* eslint-disable react/prop-types */
import React from 'react';
import { isBookingAutoAllocationBlocked } from '../../logic/helpers';
import RefreshIcon from '../../../../../../assets/icons/refresh.svg';

const BlockedAutoAllocationSection = ({ booking }) => {
  if (!isBookingAutoAllocationBlocked(booking)) return null;

  return (
    <div className="allocation-card-blocked">
      <RefreshIcon style={{ width: '1em', height: '1em', verticalAlign: 'middle', marginRight: '4px', overflow: 'visible' }} /> No auto-allocation
    </div>
  );
};

export default BlockedAutoAllocationSection;
